function QuoteEnd({ small }) {
  return (
    <svg
      width={small ? "2em" : "4em"}
      height={small ? "2em" : "4em"}
      viewBox="0 0 37 31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.822 29.954l3.59-28h-5.584l-8.744 28h10.738zm18.598 0l3.59-28h-5.584l-8.745 28H31.42z"
        fill="none"
        fillRule="nonzero"
        stroke="#0FB960"
        strokeWidth={2}
        fillOpacity={0}
      />
    </svg>
  );
}

export default QuoteEnd;
